import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import BioHeader from './components/BioHeader';
import Biography from './components/Biography';

export default function About() {
  const location = useLocation();

  usePageMeta(
    'About Keaton Brown | Baritone — Biography, Training & Career',
    'Learn about Keaton Brown, a versatile baritone with an expansive career across opera, musical theatre, oratorio, and teaching artistry. Trained at Rice University and Seagle Festival. Based in Houston, Texas.'
  );

  return (
    <main>
      <BioHeader />
      <Biography />
    </main>
  );
}